import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderBack from './components/HeaderBack';
import ProfileResetPassword from '../common/forms/ProfileResetPassword';
import ProfileChangePhoneNumber from '../common/forms/ProfileChangePhoneNumber';
import isWindow from 'components/common/helpers/isWindow';
import SecureLoadingContent from 'components/components/common/SecureLoadingContent';
import resizer from 'components/common/Resizer';
import DesktopView from './ProfileComponents/DesktopView';
import MobileView from './ProfileComponents/MobileView';
import { connect } from 'react-redux';
import {STANDARD} from 'components/common/constants/authConstants';
class Profile extends Component {

  isStandardAccount = () => {
    return parseInt(this.props.customer.account_type) === parseInt(STANDARD);
  }

  render() {
    const isMobile = this.props.windowWidth <= 639;
    var props = {
      isStandardAccount: this.isStandardAccount(),
      locale: this.props.locale
    }

    if (isMobile) {
      var content = (<MobileView {...props} />);
    } else {
      var content = (<DesktopView {...props} />);
    }
    return (
      <SecureLoadingContent>
        {content}
      </SecureLoadingContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    customer: state.auth.customer
  };
};

export default resizer(
  connect(mapStateToProps)(Profile)
);